











































import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import { err } from '@/commons/toast';

@Component({
    components: {},
})
export default class ForgotPassword extends Vue {
    private email: string = '';
    private loading = false;
    private mailSent = false;

    private async sendRemainder() {
        const valid = await this.$validator.validateAll();

        if (!valid) {
            this.$validator.errors.all().forEach((error) => {
                err(error);
            });

            return;
        }

        this.loading = true;

        user.sendForgotPassword(this.email)
            .then(() => {
                this.loading = false;
                this.mailSent = true;
            })
            .catch(() => {
                err(this.$t(`We're unable to send the password reset email`).toString());
                this.loading = false;
            });
    }
}
